import React from 'react';

const Circle = ({ cx, cy, color, mouseEnter, mouseLeave, index }) => (
  <circle
    cx={cx}
    cy={cy}
    fill={color}
    r={4}
    onMouseEnter={() => mouseEnter(cx, cy, index)}
    onMouseLeave={() => mouseLeave()}
  />
);

export default Circle;
